<template>
    <div class="material">
        <div class="header-tool">
            <div class="header-tool-info">
                <Breadcrumb>
                    <BreadcrumbItem to="/host/index/home">首页</BreadcrumbItem>
                    <BreadcrumbItem>管理</BreadcrumbItem>
                    <BreadcrumbItem>用户</BreadcrumbItem>
                </Breadcrumb>
                <div class="header-tool-title">用户</div>
            </div>
            <div class="header-tool-box">
                <div class="htb-item" @click="exportExcel()">
                    <i
                        class="icon iconfont icon-downLoad2"
                        style="font-size:20px;"
                    ></i>
                    <span style="margin-top:-1px;">导出</span>
                </div>
            </div>
        </div>
        <div class="layout-content" style="background: transparent;">
            <Table :border="false" row-key="id" :columns="columns" :data="list">
                <template slot-scope="{row, index}" slot="logo">
                    <img
                        style="width:40px;height:40px;border-radius:50%;"
                        v-if="row.logo"
                        :src="row.logo"
                    />
                    <img
                        style="width:40px;height:40px;border-radius:50%;"
                        v-else
                        src="@assets/img/empty.png"
                    />
                </template>
                <template slot-scope="{row, index}" slot="name">{{
                    row.name
                }}</template>
                <template slot-scope="{row, index}" slot="compName">{{
                    row.compName
                }}</template>
                <template slot-scope="{row, index}" slot="jobTitle">{{
                    row.jobTitle
                }}</template>
                <template slot-scope="{row, index}" slot="domain">{{
                    row.domainBelong
                }}</template>
                <template slot-scope="{row, index}" slot="phoneNumber">{{
                    row.phoneNumber
                }}</template>
                <template slot-scope="{row, index}" slot="email">{{
                    row.email
                }}</template>
                <template slot-scope="{row, index}" slot="area">
                    <template v-if="row.province"
                        >{{ row.province }}
                    </template>
                    <!-- <template v-if="row.province"
                        >{{ row.province }}
                    </template> -->
                    <template v-if="row.city">{{ row.city }}</template>
                    <template v-if="row.county"
                        >{{ row.county }}
                    </template>
                </template>
                <template slot-scope="{row, index}" slot="product">{{
                    row.productPerfer
                }}</template>
                <template slot-scope="{row, index}" slot="time"
                    >{{ row.inTime | moment('YYYY/MM/DD HH:mm:ss') }}
                </template>

                <template slot-scope="{row, index}" slot="blacklist">
                    <i-switch
                        v-model="row.isBlackList"
                        @on-change="changeSwitch(row, $event)"
                    >
                        <Icon type="android-done" slot="open"></Icon>
                        <Icon type="android-close" slot="close"></Icon>
                    </i-switch>
                </template>
            </Table>
            <div
                class="my-page"
                v-if="totalCount > pageSize"
                style="margin: 20px;text-align: center;"
            >
                <Page
                    show-total
                    show-elevator
                    :page-size="pageSize"
                    :current="pageIndex"
                    :total="totalCount"
                    @on-change="changePage"
                    @on-page-size-change="changePageSize"
                />
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions} from 'vuex'
let moment = require('moment')

export default {
    name: 'host-ex-user',
    data() {
        return {
            columns: [
                {
                    title: '头像',
                    slot: 'logo',
                    key: 'logo',
                    align: 'center',
                },
                {
                    title: '姓名',
                    key: 'name',
                    slot: 'name',
                    align: 'center',
                },
                {
                    title: '公司',
                    key: 'compName',
                    slot: 'compName',
                    align: 'center',
                },
                {
                    title: '职务',
                    key: 'jobTitle',
                    slot: 'jobTitle',
                    align: 'center',
                },
                {
                    title: '所在领域',
                    key: 'domain',
                    slot: 'domain',
                    align: 'center',
                },
                {
                    title: '手机',
                    key: 'phoneNumber',
                    slot: 'phoneNumber',
                    align: 'center',
                },
                {
                    title: '邮箱',
                    key: 'email',
                    slot: 'email',
                    align: 'center',
                },
                {
                    title: '地区',
                    key: 'area',
                    slot: 'area',
                    align: 'center',
                },
                {
                    title: '产品类别偏好',
                    key: 'product',
                    slot: 'product',
                    align: 'center',
                },
                {
                    title: '注册时间',
                    key: 'time',
                    slot: 'time',
                    align: 'center',
                },
                {
                    title: '黑名单',
                    key: 'blacklist',
                    slot: 'blacklist',
                    align: 'center',
                },
            ],
            list: [],
            pageIndex: 1,
            pageSize: 20,
            totalCount: 0,
        }
    },
    components: {},
    computed: {},
    created() {
        this.init()
    },
    methods: {
        ...mapActions({
            getHostUser: 'hostSetModule/getHostUser',
            getHostUserJoinBlackList: 'hostSetModule/getHostUserJoinBlackList',
        }),
        async init() {
            let userList = await this.getHostUser({
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
            })
            if (userList && userList.items.length) {
                this.list = userList.items
            }
            this.pageIndex = userList.pageIndex
            this.pageSize = userList.pageSize
            this.totalCount = userList.totalCount
            // console.log(123,this.list);
        },
        changePage(e) {
            this.pageIndex = e
            this.init()
        },
        changePageSize(e) {
            this.pageSize = e
            this.init()
        },
        async exportExcel() {
            this.$router.push('/host/index/ex/export')
            // let userList = await this.getHostUser(
            //   {
            //     pageIndex: 1,
            //     pageSize: 5000,
            //   }
            // );
            // if (userList && userList.items && userList.items.length) {
            //   const exData = this.transformData(userList.items);
            //   require.ensure([], () => {
            //     const {
            //       export_json_to_excel
            //     } = require("../../../../../assets/js/Export2Excel"); //这个地址和页面的位置相关，这个地址是Export2Excel.js相对于页面的相对位置
            //     const tHeader = ["姓名", "公司", "职务", "手机", "地区", "注册时间"]; // 表头
            //     const filterVal = ["name", "compName", "jobTitle", "phoneNumber", "address", "time"]; // 数据
            //     const data = this.formatJson(filterVal, exData);
            //     export_json_to_excel(tHeader, data, "用户"); //列表excel  这个是导出表单的名称
            //   });
            // } else {
            //   this.$Message.warning("暂无用户数据！");
            // }
        },
        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]))
        },
        transformData(data) {
            // 转换数据
            let arr = []
            data.forEach((c) => {
                arr.push({
                    name: c.name || '',
                    compName: c.compName || '',
                    jobTitle: c.jobTitle || '',
                    phoneNumber: c.phoneNumber || '',
                    address:
                        (c.province || '') + (c.city || '') + (c.county || ''),
                    time: moment(c.inTime).format('YYYY/MM/DD HH:mm:ss') || '',
                })
            })
            return arr
        },
        async changeSwitch(row, event) {
            let blackList = await this.getHostUserJoinBlackList(row.id)
            if (blackList && blackList.successed) {
                this.$Message.success('操作成功')
                this.init()
            } else {
                this.$Message.error('操作失败，请重新尝试')
            }

            //     this.$Message.success('操作成功')
            //     this.init()
            //   } else {
            //     this.$Message.error('操作失败，请重新尝试')
            //   }
            //   console.log(row)
            //   console.log(event)
        },
    },
}
</script>

<style scoped lang="scss">
.header-tool-utils {
    margin-top: 20px;
    button {
        margin-right: 20px;
    }
}
.logo {
    width: 60px;
    height: 60px;
    display: inline-block;
}
.cate-item {
    width: 200px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; // 显示的行数
    overflow: hidden;
}
.layout-content {
    table {
    }
}
</style>

<style lang="scss">
.cate-item {
    width: 200px;
    &:hover {
        color: #1890ff;
    }
}
.cate-pop-item {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    margin-top: 6px;
    .cate-brand {
        display: inline-block;
        border: solid 1px #f0f0f0;
        background-color: #f5f5f5;
        padding: 0 6px;
        margin-right: 6px;
        margin-bottom: 6px;
        color: #333;
        :hover {
            color: #333;
        }
        &-close {
            font-size: 21px;
            position: relative;
            top: 1px;
        }
    }
}
</style>
